import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { FormsModule } from '@angular/forms';
import { StoredScoreRowModule } from './stored-score-row/stored-score-row.module';
import { ParaDrawerModule } from '../components/para-drawer/para-drawer.module';
import { LmsAssessmentSlideoutComponent } from './lms-assessment-slideout.component';
import { AvatarComponent } from './avatar/avatar.component';
import { StudentBadgeModule } from '../components/student-badge/student-badge.module';
import { ParaMilestoneStatusStripModule } from '../components/para-milestone-status-strip/para-milestone-status-strip.module';

@NgModule({
	imports: [CommonModule, PortalModule, FormsModule, StoredScoreRowModule, ParaDrawerModule, StudentBadgeModule, ParaMilestoneStatusStripModule],
	declarations: [LmsAssessmentSlideoutComponent, AvatarComponent],
	exports: [LmsAssessmentSlideoutComponent, AvatarComponent],
})
export class LmsAssessmentModule {}
